/* Liefertermine Cosmadic – Mini-Cart & PDP
   - Cutoff 14:00 (Shopzeit per data-shop-hour)
   - VERSANDTAGE: Mo–Fr (keine Samstage, keine Sonntage, keine bundesweiten Feiertage)
   - ZUSTELLTAGE: Mo–Sa (Samstag erlaubt), nur Sonntag + bundesweite Feiertage überspringen
   - Mini-Cart: ".delivery-estimate-range"  => "Mi. 10.09 – Do. 11.09"
   - PDP:       ".delivery-estimate-inline" => "Mi., 10.09."
   - DE: 1–2 Tage | AT: 2–3 Tage
*/
(function(){
  var RANGE_SELECTOR  = '.delivery-estimate-range';
  var INLINE_SELECTOR = '.delivery-estimate-inline';

  function pad(n){ return (n<10?'0':'')+n; }
  function formatDDMM(d){ return pad(d.getDate())+'.'+pad(d.getMonth()+1); }
  function weekdayDE(d){ return ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'][d.getDay()]; }

  // Ostersonntag (Meeus/Jones/Butcher)
  function easterSunday(year){
    var a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),
        g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,
        m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),
        day=((h+l-7*m+114)%31)+1;
    return new Date(year, month-1, day);
  }
  function addDays(d,n){ var x=new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate()+n); return x; }
  function key(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }

  // Bundesweite Feiertage
  function germanHolidays(year){
    var s=new Set(), E=easterSunday(year);
    [
      addDays(E,-2),   // Karfreitag
      addDays(E, 1),   // Ostermontag
      addDays(E,39),   // Christi Himmelfahrt
      addDays(E,50),   // Pfingstmontag
      new Date(year,0,1),   // Neujahr
      new Date(year,4,1),   // 1. Mai
      new Date(year,9,3),   // Tag der Deutschen Einheit
      new Date(year,11,25), // 25.12
      new Date(year,11,26)  // 26.12
    ].forEach(function(d){ s.add(key(d)); });
    return s;
  }

  function isSunday(d){ return d.getDay() === 0; }
  function isSaturday(d){ return d.getDay() === 6; }

  // Versandtage: Mo–Fr (keine Feiertage, kein Sa/So)
  function isDispatchBlocked(d, holi){
    return isSunday(d) || isSaturday(d) || holi.has(key(d));
  }

  // Zustelltage: Mo–Sa (keine Feiertage, kein Sonntag)
  function isDeliveryBlocked(d, holi){
    return isSunday(d) || holi.has(key(d));
  }

  // Holt Shop-Stunde aus nächstem Vorfahren mit data-shop-hour (Fallback: Clientzeit)
  function getShopHourFor(el){
    var host = el && (el.closest('[data-shop-hour]') || document.querySelector('[data-shop-hour]'));
    if (host){
      var h = parseInt(host.getAttribute('data-shop-hour'), 10);
      if (!isNaN(h)) return h;
    }
    return (new Date()).getHours();
  }

  // Holt Ländercode (AT/IT/DE) aus nächstem Vorfahren mit data-country (Fallback: 'DE')
  function getCountryFor(el){
    var host = el && (el.closest('[data-country]') || document.querySelector('[data-country]'));
    if (host){
      var c = (host.getAttribute('data-country') || '').toUpperCase();
      if (c) return c;
    }
    return 'DE';
  }

  function addDeliveryDaysFrom(shipDate, days, holi){
    var d = new Date(shipDate.getFullYear(), shipDate.getMonth(), shipDate.getDate());
    var delivered = 0;
    while (delivered < days) {
      d = addDays(d, 1);
      if (!isDeliveryBlocked(d, holi)) delivered++;
    }
    return d;
  }

  function computeDates(hourNow, countryCode){
    var now = new Date();
    var y = now.getFullYear();
    var holi = new Set();
    germanHolidays(y).forEach(function(x){ holi.add(x); });
    germanHolidays(y+1).forEach(function(x){ holi.add(x); }); // falls Jahreswechsel

    // Lieferfenster je Land
    var minDays = 1, maxDays = 2; // DE default
    if (['AT', 'IT'].indexOf((countryCode || '').toUpperCase()) !== -1){
    minDays = 2;
    maxDays = 3;
    }

    // 1) Nächstes Versanddatum bestimmen (Cutoff + nur Mo–Fr, keine Feiertage)
    var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (hourNow >= 14) ship = addDays(ship, 1); // nach 14 Uhr geht Versand erst am nächsten Versandtag raus
    while (isDispatchBlocked(ship, holi)) {
      ship = addDays(ship, 1);
    }

    // 2) Zustellung ab Versanddatum: +minDays bis +maxDays ZUSTELL-Tage (Sa erlaubt, So/Feiertage auslassen)
    var d1 = addDeliveryDaysFrom(ship, minDays, holi);
    var d2 = addDeliveryDaysFrom(ship, maxDays, holi);

    return { startDate: d1, endDate: d2 };
  }

  function textRange(d1, d2){
    // "Mi. 10.09 – Do. 11.09"
    return weekdayDE(d1)+' '+formatDDMM(d1)+' – '+weekdayDE(d2)+' '+formatDDMM(d2);
  }
  function textInline(d){
    // "Mi., 10.09."
    return weekdayDE(d)+', '+formatDDMM(d)+'.';
  }

  function paintAll(){
    // PDP (Inline: frühester Tag)
    var inlineNodes = Array.prototype.slice.call(document.querySelectorAll(INLINE_SELECTOR));
    inlineNodes.forEach(function(el){
      try{
        var hour = getShopHourFor(el);
        var country = getCountryFor(el);
        var ds = computeDates(hour, country);
        el.textContent = textInline(ds.startDate);
      } catch(e){}
    });

    // Mini-Cart (Range: frühester – spätester)
    var rangeNodes = Array.prototype.slice.call(document.querySelectorAll(RANGE_SELECTOR));
    rangeNodes.forEach(function(el){
      try{
        var hour = getShopHourFor(el);
        var country = getCountryFor(el);
        var ds = computeDates(hour, country);
        el.textContent = textRange(ds.startDate, ds.endDate);
      } catch(e){}
    });
  }

  function refresh(){ paintAll(); }

  // initial + kleine Retries (Ajax/Drawer)
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', refresh); } else { refresh(); }
  setTimeout(refresh, 200);
  setTimeout(refresh, 800);

  // gängige Shopify Events
  ['cart:updated','shopify:section:load','shopify:section:select'].forEach(function(evt){
    document.addEventListener(evt, refresh);
  });

  // MutationObserver: füllt neu eingefügte Blöcke
  var obs = new MutationObserver(function(muts){
    var found = false;
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if(n.nodeType!==1) return;
        if(n.matches && (n.matches(INLINE_SELECTOR)||n.matches(RANGE_SELECTOR))) found = true;
        else if(n.querySelector && (n.querySelector(INLINE_SELECTOR)||n.querySelector(RANGE_SELECTOR))) found = true;
      });
    });
    if(found) refresh();
  });
  obs.observe(document.documentElement,{childList:true,subtree:true});
})();
